<script lang="ts">
    import ReviewEmptyStarsIcon from "./icons/ReviewsEmptyStarIcon.svelte";
    import ReviewsStarIcon from "./icons/ReviewsStarIcon.svelte";

    export let rating: number;
</script>

<div class="gw-rv-rating" aria-label={`${rating} out of 5 ratings`} role="img">
    {#each [1, 2, 3, 4, 5] as starNumber}
        {#if rating >= starNumber}
            <ReviewsStarIcon />
        {:else}
            <ReviewEmptyStarsIcon />
        {/if}
    {/each}
</div>

<style lang="postcss">
    .gw-rv-rating {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    :global(.gw-rv-rating svg) {
        margin-right: -3px;
    }
</style>
